import { Link } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { eur } from "../lib/format";
import { cn } from "../lib/utils";

const TONE = {
  ok: { bar: "bg-emerald-500", text: "text-emerald-300", label: "Nei limiti" },
  attenzione: { bar: "bg-orange-500", text: "text-orange-300", label: "Oltre l'80%" },
  superato: { bar: "bg-red-500", text: "text-red-300", label: "Budget superato" },
};

const pctText = (p) => `${p.toLocaleString("it-IT", { maximumFractionDigits: 1 })}%`;

export function BudgetMeter({ usage, testid, className }) {
  if (!usage || usage.pct == null) return null;
  const t = TONE[usage.level];
  return (
    <div className={cn("rounded-lg border border-border/60 bg-background/40 p-2.5", className)} data-testid={testid}>
      <div className="flex items-center justify-between gap-2 text-xs">
        <span className={cn("flex items-center gap-1 font-semibold", t.text)}>
          {usage.level !== "ok" && <AlertTriangle className="h-3.5 w-3.5" />}{t.label}
        </span>
        <span className={cn("num font-semibold", t.text)} data-testid={testid && `${testid}-pct`}>{pctText(usage.pct)}</span>
      </div>
      <div className="relative h-2 rounded-full bg-background mt-1.5 overflow-hidden">
        <div className={cn("h-full rounded-full transition-[width] duration-500", t.bar)} style={{ width: `${Math.min(usage.pct, 100)}%` }} />
        <span className="absolute top-0 bottom-0 w-px bg-white/40" style={{ left: "80%" }} />
      </div>
      <div className="text-[11px] text-muted-foreground num mt-1">Costi {eur(usage.costs)} su {eur(usage.value)}</div>
    </div>
  );
}

export function BudgetAlertsBanner({ items }) {
  if (!items?.length) return null;
  const over = items.filter((a) => a.level === "superato").length;
  return (
    <section className={cn("surface p-4 sm:p-5 mb-6 fade-up", over ? "border-red-600/60" : "border-orange-500/60")} data-testid="budget-alerts-banner">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className={cn("h-5 w-5", over ? "text-red-400" : "text-orange-400")} />
        <h2 className="text-base md:text-lg font-semibold">Cantieri vicini allo sforamento</h2>
        <span className="text-xs text-muted-foreground">{over ? `${over} oltre il budget · ` : ""}{items.length} oltre l'80% del Valore cantiere</span>
      </div>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {items.map((a) => (
          <Link key={a.site_id} to={`/cantieri/${a.site_id}?tab=economia`} className="rounded-lg border border-border p-3 hover:border-amber-500/60 transition-colors" data-testid={`budget-alert-${a.site_id}`}>
            <div className="flex items-center justify-between gap-2 mb-2">
              <span className="min-w-0 truncate"><span className="font-mono text-xs text-amber-400 mr-1.5">{a.site_code}</span><span className="font-semibold text-sm">{a.site_name}</span></span>
              <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
            </div>
            <BudgetMeter usage={a} className="border-0 bg-transparent p-0" />
          </Link>
        ))}
      </div>
    </section>
  );
}
